import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

const BoxDiv = styled.div`
  background-color: #fff;
  width: 100%;
  margin: 0px auto;
`;

const Box = ({ children }) => (
  <BoxDiv>{children}</BoxDiv>
);

Box.propTypes = {
  children: PropTypes.node
};

Box.defaultProps = {
  children: null
};

export default Box;

export { BoxDiv };



// WEBPACK FOOTER //
// ./src/components/box.jsx